import { render, staticRenderFns } from "./CsrDreamDungeon.vue?vue&type=template&id=10552b16&scoped=true"
import script from "./CsrDreamDungeon.vue?vue&type=script&lang=js"
export * from "./CsrDreamDungeon.vue?vue&type=script&lang=js"
import style0 from "./CsrDreamDungeon.vue?vue&type=style&index=0&id=10552b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10552b16",
  null
  
)

export default component.exports